/** Five stars, keyboard-reachable, with a hover preview. */
import { useState } from 'react'

export default function Stars({
  value,
  onChange,
  busy,
}: {
  value: number
  onChange: (stars: number) => void
  busy?: boolean
}) {
  const [hover, setHover] = useState(0)
  const shown = hover || value

  return (
    <div
      className="flex gap-1"
      role="radiogroup"
      aria-label="Your rating"
      onMouseLeave={() => setHover(0)}
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          role="radio"
          aria-checked={value === star}
          aria-label={`${star} ${star === 1 ? 'star' : 'stars'}`}
          disabled={busy}
          onMouseEnter={() => setHover(star)}
          onFocus={() => setHover(star)}
          onClick={() => onChange(star)}
          className={`text-2xl leading-none transition disabled:opacity-50 ${
            star <= shown ? 'text-wine-400' : 'text-stone-700 hover:text-stone-500'
          }`}
        >
          ★
        </button>
      ))}
    </div>
  )
}
